export enum AppTableFeature {
  DEFAULT = "default",
  CLIENTS = "clients",
  WORKFORCE = "workforce",
}
